import dayjs from 'dayjs';

export const getFullYear = () => new Date().getFullYear();

export const getIsBuiltInTheFuture = (builtYear: number) =>
  dayjs()
    .year(builtYear || 0)
    .isAfter(dayjs());
